import { render, staticRenderFns } from "./App.vue?vue&type=template&id=a284c9ec"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=a284c9ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports